// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ULvr","col":"styles_col__1n3fj"};